import {ResponseMessage} from "../response_message";
import {MessageTypes} from "../message_types";

export class ContentStatisticResponseMessage extends ResponseMessage {
    constructor() {
        super()
        this.type = MessageTypes.ContentStatisticResponse;
    }
}
